var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xl-4 col-md-6 col-sm-12 profile-card-2" },
    [
      _c(
        "div",
        {
          staticClass: "card shadow-none",
          staticStyle: { width: "240px", border: "none" },
        },
        [
          _c("div", { staticClass: "card-header mx-auto pb-0" }, [
            _c("div", { staticClass: "row m-0" }, [
              _c("div", { staticClass: "col-sm-12 text-center" }, [
                _c("div", { staticClass: "avatar avatar-xl" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src:
                        _vm.owner.avatar !== null
                          ? _vm.owner.avatar.url
                          : "/images/avatar.png",
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "/member/profiles/" + _vm.owner.username } },
                  [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.owner.first_name + " " + _vm.owner.last_name
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm.owner.roles.hasOwnProperty("title") &&
                      _vm.owner.roles[0].title === "Admin"
                        ? _c("img", {
                            staticStyle: { "margin-top": "-5px" },
                            attrs: {
                              src: "/images/badges/admin.png",
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              title: "Administrator",
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12 text-center" }, [
                _c("div", { staticStyle: { "margin-top": "-5px" } }, [
                  _c("span", {
                    staticClass: "font-small-2 text-light",
                    domProps: { textContent: _vm._s(_vm.owner.position) },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-small-2 text-light" }, [
                    _vm._v(" at "),
                  ]),
                  _c("span", {
                    staticClass: "font-small-2 text-light",
                    domProps: { textContent: _vm._s(_vm.owner.organisation) },
                  }),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "card-body text-center mx-auto p-0" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between mt-2" },
                [
                  _c("div", { staticClass: "followers" }, [
                    _c("p", {
                      staticClass: "font-weight-bold font-medium-2 mb-0",
                      domProps: { textContent: _vm._s(_vm.followers) },
                    }),
                    _vm._v(" "),
                    _c("span", {}, [
                      _vm._v(_vm._s(_vm.__("globals.contacts"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [_c("follow", { attrs: { data: _vm.owner } })], 1),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-05" }, [
                _c(
                  "a",
                  { attrs: { href: "/member/profiles/" + _vm.owner.username } },
                  [
                    _c(
                      "button",
                      { staticClass: "btn btn-sm btn-outline-light mt-1" },
                      [
                        _vm._v(
                          _vm._s(_vm.__("globals.view_profile_button")) + " "
                        ),
                        _c("i", { staticClass: "feather icon-chevron-right" }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }